import { useEffect, useState } from "react";
import api from "@/lib/api";

const ACTION_ICON = {
  "user.create": "fa-user-plus",
  "user.update": "fa-user-pen",
  "user.delete": "fa-user-xmark",
  "user.password_reset": "fa-key",
  "response.submit": "fa-paper-plane",
};

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit?limit=300").then(({ data }) => setItems(data)); }, []);

  return (
    <div className="p-8 lg:p-12 max-w-5xl mx-auto">
      <div className="overline mb-2">Administração</div>
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-900 mb-2">Trilha de auditoria</h1>
      <p className="text-slate-600 mb-8">Eventos do sistema (300 mais recentes). Imutável e exigido para auditoria de SST e LGPD.</p>

      <div className="card">
        {items.length === 0 ? (
          <div className="text-slate-500 py-8 text-center">Nenhum evento registrado.</div>
        ) : (
          <ul className="space-y-2">
            {items.map((ev) => (
              <li key={ev.id} className="flex items-start gap-3 border-b border-slate-100 pb-2"
                  data-testid={`audit-row-${ev.id}`}>
                <i className={`fa-solid ${ACTION_ICON[ev.action] || "fa-circle"} text-sollute-green mt-1 w-4 text-center`}></i>
                <div className="flex-1">
                  <div className="text-sm">
                    <span className="font-mono text-xs text-slate-500">{new Date(ev.at).toLocaleString("pt-BR")}</span>
                    <span className="font-bold text-slate-900 mx-2">{ev.action}</span>
                  </div>
                  <div className="text-xs text-slate-600">
                    {ev.actor_email ? <>Por <strong>{ev.actor_email}</strong> ({ev.actor_role})</> : <em>anônimo</em>}
                  </div>
                  {ev.context && Object.keys(ev.context).length > 0 && (
                    <pre className="text-[10px] font-mono text-slate-500 bg-slate-50 p-2 mt-1 overflow-x-auto">
                      {JSON.stringify(ev.context, null, 2)}
                    </pre>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
